import { Navigate, Outlet, useLocation } from "react-router";

import { ROUTES } from "@/constants/routes";
import { useAuth } from "@/providers/auth-provider";

/**
 * Layout route that keeps unauthenticated users out of the app.
 *
 * Note this is only the outermost gate. Real enforcement is server-side: the
 * Shadow Realm has its own Kinde environment and API audience, so a token
 * minted anywhere else is rejected by API Gateway before a Lambda runs — on
 * issuer and on audience. Being able to sign in here is the authorization.
 */
export const ProtectedLayout = () => {
	const { isAuthenticated, isLoadingAuth } = useAuth();
	const location = useLocation();

	if (isLoadingAuth) {
		return (
			<div className="flex h-dvh items-center justify-center">
				<p className="text-secondary text-sm">Loading…</p>
			</div>
		);
	}

	if (!isAuthenticated) {
		return <Navigate replace state={{ from: location }} to={ROUTES.LOGIN} />;
	}

	return <Outlet />;
};
